import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const token = localStorage.getItem('chroma-token'); 

// 1. PREPARACIÓN DE LA PETICIÓN
  // En lugar de devolver inmediatamente, guardamos la petición que vamos a usar en una variable.
  let request = req;

  if (token) {
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  // 2. ENVÍO Y MANEJO DE RESPUESTA
  // Usamos 'request' (que puede ser la original o la clonada)
  return next(request).pipe(
    
    // Capturamos cualquier error que venga del servidor
    catchError((error: HttpErrorResponse) => {
      
      // Verificamos si es el error 401 (Token inválido o expirado)
      if (error.status === 401) {
        console.warn('Sesión expirada o no autorizada. Cerrando sesión...');
        
        // A. Limpiamos el token y actualizamos la señal (usando tu método existente)
        authService.logout();
        router.navigate(['/login'], { 
          queryParams: { msg: 'Sesión caducada' }
        });
      }

      // C. Importante: Re-lanzamos el error para que el componente también se entere
      // (Por si quieres mostrar un mensaje específico en el formulario de login, por ejemplo)
      return throwError(() => error);
    })
  );
};